const require_asText = require("../richtext/asText.cjs");
//#region src/helpers/asText.ts
const asText = (richTextField, ...configObjectOrTuple) => {
	if (richTextField) {
		const [configObjectOrSeparator] = configObjectOrTuple;
		let config;
		if (typeof configObjectOrSeparator === "string") config = { separator: configObjectOrSeparator };
		else config = { ...configObjectOrSeparator };
		return require_asText.asText(richTextField, config.separator);
	} else return null;
};
//#endregion
exports.asText = asText;

//# sourceMappingURL=asText.cjs.map